import { functionFormat, breakLines, splitHtmlParagraphs } from "./functionFormat";
import { functionGet } from "./functionGet";

export const templatesFunctions = {
  splitParagraphs: splitHtmlParagraphs,
  format: functionFormat,
  addBreakLines: breakLines,
  get: functionGet,
};
